// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#scan[data-v-77069800]{color:#0e6ecd;font-size:2rem;text-align:center}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/app/end/job.vue"],"names":[],"mappings":"AACA,uBAGI,aAAA,CADA,cAAA,CADA,iBAEJ","sourcesContent":["\n#scan {\n    text-align: center;\n    font-size: 2rem;\n    color: #0e6ecd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
